import { Box, Button, Link, Text, useMediaQuery } from '@chakra-ui/react';
import { hyphenatePhoneNumber } from '@constants/phoneNumbers';
import CtaWrapper from './CtaWrapper';

function TalkToAnExpert({ phoneNumber }) {
  const [isLargerThan500] = useMediaQuery('(min-width: 500px)');

  const hyphenatedPhoneNumber = hyphenatePhoneNumber(phoneNumber);
  const text = isLargerThan500 ? `Call ${hyphenatedPhoneNumber} to Talk to an Expert` : `Call ${hyphenatedPhoneNumber}`;

  const renderCta = () => (
    <Box display="flex" flexDirection="column">
      <Text fontSize="xl">Talk to one of our Licensed Medicare Agents today to find the right plans for you.</Text>
      <Link href={`tel:${hyphenatedPhoneNumber}`} width="100%" margin="1rem 0 0 0">
        <Button
          colorScheme="blue"
          id="talk_to_expert_call_link"
          size="lg"
          w="100%"
          suppressHydrationWarning // Component depends on Media Query and SSR
        >
          {text}
        </Button>
      </Link>
    </Box>
  );

  return <CtaWrapper header="Speak with a Medicare Expert" renderCta={renderCta} />;
}

export default TalkToAnExpert;
